export default __webpack_public_path__ + "static/media/liquidezIcon.f54b83b1.svg";